import { useClientSideTranslation } from 'src/services/i18n'
import SyncIcon from 'src/app/assets/icons/ico-sync-alt.svg'
import { useGetCurrentLanguage } from 'src/store/game'
import { Button } from '../../Button'

type Props = Readonly<{
  onStopBetting: () => void
  autoCashoutEnabled?: boolean
  autoCashoutMultiplier?: number
}>

export function AutoBetPanel({ onStopBetting, autoCashoutEnabled, autoCashoutMultiplier }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  return (
    <div className="next-race-bet-panel">
      <div className="next-race-bet-panel__header">
        <div className="next-race-bet-label">
          <SyncIcon />
          <span>
            {t('Auto bet active')}
            {autoCashoutEnabled && autoCashoutMultiplier && (
              <span className="auto-cashout-badge"> @ {autoCashoutMultiplier.toFixed(2)}x</span>
            )}
          </span>
        </div>
        <div className="next-race-bet-actions">
          <Button className="btn btn-cancel" onClick={onStopBetting} type="button">
            {t('Cancel')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default AutoBetPanel
